import React from "react";
import MainModalLayout from "./main-modal-layout";

export default class MainModal extends React.Component<any, {}> {
  render() {
    const {
      img,
      className,
      onClickAccept,
      mainTitle,
      mainText,
      active,
      buttonText,
      close,
      centered,
      table,
      buttonClassName,
      inputCount,
      hideIcon
    } = this.props;

    return (
      <MainModalLayout
        className={className}
        img={img}
        onClickAccept={() => onClickAccept()}
        mainTitle={mainTitle}
        mainText={mainText}
        buttonText={buttonText}
        active={active}
        close={close}
        centered={centered}
        table={table}
        buttonClassName={buttonClassName}
        inputCount={inputCount}
        hideIcon={hideIcon}
      />
    );
  }
}
